'use client';

import { LottieAnimation } from '@/components/ui';

import { PulsingCircles } from '../PulsingCircles';

import { usePulsingCircles } from '../../hooks';

export const TrophySection = () => {
  const { showCircles } = usePulsingCircles();

  return (
    <div className="relative w-full flex justify-center items-start flex-shrink-0">
      <PulsingCircles visible={showCircles} />
      <div className="w-48 h-48 md:w-56 md:h-56 flex items-center justify-center relative z-10">
        <LottieAnimation
          loop={false}
          src="/animations/prize_trophy.json"
          className="w-48 h-48 md:w-56 md:h-56"
        />
      </div>
    </div>
  );
};
